import styled, { css } from 'styled-components';
import { Palette } from 'config';

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const Text = styled.p`
  ${highlightStyle}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ field }) =>
    field === 'campaigns' &&
    css`
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: ${Palette.PrimaryGray._700};
    `}
`;
